export function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
   * Parses the status object to determine the current status of the company.
   * @param {object} status - The status object containing company information 
   * @returns - An object containing the current status
   */
export const parseStatus = (status) => {
  const currentStatus = {}
  if (status.status.active
    && status.status.inBankruptcy === false
    && status.status.inLiquidation === false
    && status.status.inReorganization === false
  ) {
    currentStatus.status = 'ACTIVE';
  } else {
    currentStatus.status = 'REJECTED';
    currentStatus.rejectionReason =
      !status.status.active ? 'INACTIVE' :
        status.status.inBankruptcy ? 'BANKRUPTCY' :
          status.status.inLiquidation ? 'LIQUIDATION' :
            status.status.inReorganization ? 'REORGANIZATION' :
              'UNKNOWN';
  }

  if (!status.registrations && !status.registrations.length) {
    currentStatus.status = 'REJECTED';
    currentStatus.rejectionReason = 'NO_REGISTRATIONS';
    return currentStatus;
  }

  // Verohallinnon perustiedot
  const taxAuht = status.registrations.find(reg => (
    reg.authority === '1' &&
    reg.registry === '4' &&
    reg.status === 'Rekisterissä'
  ))

  // Only tax authority registration
  if (status.registrations.length === 1 && taxAuht) {
    currentStatus.status = 'REJECTED';
    currentStatus.rejectionReason = 'ONLY_TAX_AUTHORITY';
  }

  // Kaupparekisterissä
  const tradeRegister = status.registrations.find(reg => (
    reg.authority === '2' &&
    reg.registry === '1'
  ))

  if (tradeRegister) {
    // Map all trade register status codes
    const tradeRegisterStatusMap = {
      'Rekisterissä': {
        tradeRegisterStatus: 'yes'
      },
      'Lakannut': {
        status: 'REJECTED',
        tradeRegisterStatus: 'ceased',
        rejectionReason: 'CEASED_OPERATIONS'
      },
      'Rekisteröimätön': {
        status: 'REJECTED',
        tradeRegisterStatus: 'unregistered',
        rejectionReason: 'NO_TRADE_REGISTER'
      },
      'Poistettu rekisteristä': {
        status: 'REJECTED',
        tradeRegisterStatus: 'removed',
        rejectionReason: 'REMOVED_FROM_REGISTER'
      },
      'Ei rekisteröity perustaminen': {
        status: 'REJECTED',
        tradeRegisterStatus: 'not_registered_establishment',
        rejectionReason: 'NOT_REGISTERED_ESTABLISHMENT'
      }
    };

    const statusConfig = tradeRegisterStatusMap[tradeRegister.status] || {
      status: 'REJECTED',
      tradeRegisterStatus: 'unknown',
      rejectionReason: 'UNKNOWN_TRADE_REGISTER_STATUS'
    };

    Object.assign(currentStatus, statusConfig);
  }

  if (taxAuht) {
    currentStatus.taxAuthorityStatus = 'yes';
  }

  if (!taxAuht) {
    currentStatus.status = 'REJECTED';
    currentStatus.rejectionReason = 'NO_TAX_AUTHORITY';
  }

  currentStatus.vatRegistered = status.vatRegistered; // ALV-rekisterissä

  currentStatus.paymentRegistered = status.paymentRegistered // Ennakkoperintärekisterissä

  return currentStatus;

}

export const parseCompanyData = (data) => {
  // Helper function to get registration status (returns actual status or null)
  const getRegistrationStatus = (authority, registry) => {
    const registration = data.registrations?.find(reg =>
      reg.authority === authority &&
      reg.registry === registry
    );
    return registration ? registration.status : null;
  };

  // Helper function to check if registered with any status
  const hasRegistration = (authority, registry) => {
    return data.registrations?.find(reg =>
      reg.authority === authority &&
      reg.registry === registry
    ) ? true : false;
  };

  const companyData = {
    businessId: data.businessId || '',
    name: data.businessName || '',
    address: [`${data.postalAddress?.street || ''}`, `${data.postalAddress?.houseNumber || ''}`, `${data.postalAddress?.postalCode || ''}`, `${data.postalAddress?.city || ''}`, `${data.postalAddress?.country || ''}`].filter(Boolean).join(', '),
    phone: data.contactInfo?.phone || '',
    businessForm: data.businessForm || '',
    businessline: data.businessLine || '',

    // Registry presence (boolean - whether company has any entry in this registry)
    hasTradeRegister: hasRegistration('2', '1'), // Kaupparekisteri
    hasFoundationRegister: hasRegistration('2', '2'), // Säätiörekisteri
    hasAssociationRegister: hasRegistration('2', '3'), // Yhdistysrekisteri
    hasTaxAuthority: hasRegistration('1', '4'), // Verohallinnon perustiedot
    hasPrepaymentRegister: hasRegistration('1', '5'), // Ennakkoperintärekisteri
    hasVatRegistration: hasRegistration('1', '6'), // Arvonlisäverovelvollisuus
    hasEmployerRegister: hasRegistration('1', '7'), // Työnantajarekisteri
    hasInsurancePremiumTax: hasRegistration('1', '8'), // Vakuutusmaksuverovelvollisten rekisteri

    // Actual statuses (shows the real status like "Lakannut", "Liiketoiminnasta arvonlisäverovelvollinen", etc.)
    tradeRegisterStatus: getRegistrationStatus('2', '1'),
    foundationRegisterStatus: getRegistrationStatus('2', '2'),
    associationRegisterStatus: getRegistrationStatus('2', '3'),
    taxAuthorityStatus: getRegistrationStatus('1', '4'),
    prepaymentRegisterStatus: getRegistrationStatus('1', '5'),
    vatStatus: getRegistrationStatus('1', '6'),
    employerRegisterStatus: getRegistrationStatus('1', '7'),
    insurancePremiumTaxStatus: getRegistrationStatus('1', '8'),
  };

  console.log(" companyData:", companyData)
  return companyData;
}